/**
 * Cart summary display from Shopify cart_level_discount_applications.
 * Uses discount.value (e.g. "10.0") as a percentage of cart merchandise total.
 */
(function () {
  var isHooked = false;

  function getCartMerchandiseTotal(cart) {
    if (cart && typeof cart.original_total_price === 'number' && cart.original_total_price > 0) {
      return cart.original_total_price;
    }
    var total = 0;
    (cart.items || []).forEach(function (item) {
      total += item.original_line_price;
    });
    return total;
  }

  function getDiscountPercent(discount) {
    if (!discount || discount.value == null || discount.value === '') return 0;
    var value = parseFloat(discount.value);
    if (isNaN(value) || value <= 0) return 0;
    if (discount.value_type && discount.value_type !== 'percentage') return 0;
    return value;
  }

  function calculateCartDiscountTotals(cart) {
    var summarySubtotal = getCartMerchandiseTotal(cart);
    var summaryDiscount = 0;
    var summaryDiscountTitle = 'Discount';
    var applications = (cart && cart.cart_level_discount_applications) || [];

    applications.forEach(function (discount) {
      var percent = getDiscountPercent(discount);

      if (percent > 0) {
        summaryDiscount += Math.round(summarySubtotal * (percent / 100));
      } else if (discount.total_allocated_amount) {
        summaryDiscount += discount.total_allocated_amount;
      }

      if (discount.title) {
        summaryDiscountTitle = discount.title;
      }
    });

    return {
      summarySubtotal: summarySubtotal,
      summaryDiscount: summaryDiscount,
      summaryDiscountTitle: summaryDiscountTitle,
      total: summarySubtotal - summaryDiscount
    };
  }

  function updateSummaryInContainer($container, totals) {
    if (!$container.length || !window.theme || !theme.Currency) return;

    var format = theme.moneyFormatWithCurrency || theme.moneyFormat;
    var $subtotalWrap = $container.find('[data-cart-subtotal-wrap]');
    var $combo = $container.find('[data-cart-combo-discount-wrapper]');
    var $comboTitle = $container.find('[data-cart-combo-discount-title]');
    var $comboAmount = $container.find('[data-cart-combo-discount]');
    var $total = $container.find('[data-cart-subtotal]');

    if ($subtotalWrap.length) {
      $subtotalWrap.html(theme.Currency.formatMoney(totals.summarySubtotal, format));
    }

    if (totals.summaryDiscount > 0) {
      $combo.removeClass('hide');
      if ($comboTitle.length) {
        $comboTitle.html((totals.summaryDiscountTitle || 'Discount') + ':');
      }
      if ($comboAmount.length) {
        $comboAmount.html('-' + theme.Currency.formatMoney(totals.summaryDiscount, format));
      }
    } else {
      $combo.addClass('hide');
      if ($comboAmount.length) $comboAmount.html('');
    }

    if ($total.length) {
      $total.html(theme.Currency.formatMoney(totals.total, format));
    }
  }

  function applyCartLevelDiscountDisplay(cart) {
    if (!cart || typeof window.jQuery === 'undefined') return;
    var $ = window.jQuery;
    var totals = calculateCartDiscountTotals(cart);

    if (window.theme && theme.Currency) {
      updateSummaryInContainer($('#cart-dropdown'), totals);

      var $cartPage = $('[data-section-type="cart-template"]').filter(function () {
        return $(this).closest('#cart-dropdown').length === 0;
      }).first();
      if ($cartPage.length) {
        updateSummaryInContainer($cartPage, totals);
      }
    }
  }

  function cartHasCabinForBanner(cart) {
    return (cart.items || []).some(function (item) {
      var type = (item.product_type || '').toLowerCase().trim();
      var handle = (item.handle || '').toLowerCase();
      return (
        type === 'cabin_air_filter' ||
        type === 'cabin air filter' ||
        handle.indexOf('cabin-air-filter') > -1
      );
    });
  }

  function cartHasHomeForBanner(cart) {
    return (cart.items || []).some(function (item) {
      var type = (item.product_type || '').toLowerCase().trim();
      var handle = (item.handle || '').toLowerCase();
      return (
        item.product_type === 'Home Furnace Air Filter' ||
        type === 'home furnace air filter' ||
        handle.indexOf('home-furnace') > -1 ||
        handle.indexOf('hvac') > -1
      );
    });
  }

  /**
   * Cart drawer footer upsell banners:
   * cabin only -> home banner | home only -> cabin banner | both/neither -> hide
   */
  function updateCartBanners(cart) {
    if (typeof window.jQuery === 'undefined' || !cart) return;
    var $ = window.jQuery;
    var hasCabin = cartHasCabinForBanner(cart);
    var hasHome = cartHasHomeForBanner(cart);
    var $bannerDiv = $('#cart-dropdown .cart-banner-div');
    var $homeBanner = $('#cart-drawer-home-banner-wrapper');
    var $cabinBanner = $('#cart-drawer-cabin-banner-wrapper');

    if (!$bannerDiv.length) return;

    var showHomeBanner = hasCabin && !hasHome && $homeBanner.length > 0;
    var showCabinBanner = hasHome && !hasCabin && $cabinBanner.length > 0;
    var showBannerDiv = showHomeBanner || showCabinBanner;

    if (showBannerDiv) {
      $bannerDiv.css('display', '').addClass('is-visible');
    } else {
      $bannerDiv.css('display', 'none').removeClass('is-visible');
    }

    $homeBanner.css('display', showHomeBanner ? 'block' : 'none');
    $cabinBanner.css('display', showCabinBanner ? 'block' : 'none');
  }

  function scheduleCartBannerUpdate(cart) {
    if (!cart) return;
    updateCartBanners(cart);
    setTimeout(function () { updateCartBanners(cart); }, 0);
    setTimeout(function () { updateCartBanners(cart); }, 100);
    setTimeout(function () { updateCartBanners(cart); }, 400);
  }

  function refreshCartDisplay(cart) {
    applyCartLevelDiscountDisplay(cart);
    scheduleCartBannerUpdate(cart);
  }

  function onCartMutation() {
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(cartRoot + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(refreshCartDisplay)
      .catch(function () {});
  }

  function hookCartRequests() {
    if (isHooked) return;
    isHooked = true;

    if (window.jQuery) {
      window.jQuery(document).ajaxComplete(function (_e, _xhr, settings) {
        if (!settings || !settings.url) return;
        if (/\/cart\/(add|change|update|clear)/.test(settings.url)) {
          onCartMutation();
        }
      });
    }

    if (window.fetch && !window.__cartLevelDiscountFetchHooked) {
      window.__cartLevelDiscountFetchHooked = true;
      var nativeFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        return nativeFetch(input, init).then(function (response) {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart\/(add|change|update|clear)/.test(url)) {
            onCartMutation();
          }
          return response;
        });
      };
    }
  }

  function wrapUpdateCartPageSummary() {
    if (!window.theme || typeof theme.updateCartPageSummary !== 'function' || theme.__cartLevelSummaryPatched) {
      return;
    }

    theme.updateCartPageSummary = function (cart) {
      refreshCartDisplay(cart);
    };
    theme.__cartLevelSummaryPatched = true;
  }

  function patchCartInstance(instance) {
    if (!instance || instance.__cartLevelPatched) return;

    instance.__originalCreateCart = instance._createCart.bind(instance);
    instance._createCart = function (cart) {
      instance.__originalCreateCart(cart);
      refreshCartDisplay(cart);
    };
    instance.__cartLevelPatched = true;
  }

  function boot() {
    hookCartRequests();
    wrapUpdateCartPageSummary();
    patchCartInstance(window.theme && theme._cartDrawerSectionInstance);

    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(cartRoot + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.item_count) {
          refreshCartDisplay(cart);
        } else if (cart) {
          updateCartBanners(cart);
        }
      })
      .catch(function () {});

    if ((!window.theme || !theme._cartDrawerSectionInstance || !theme._cartDrawerSectionInstance.__cartLevelPatched ||
        !theme.__cartLevelSummaryPatched) && (boot.attempts || 0) < 40) {
      boot.attempts = (boot.attempts || 0) + 1;
      setTimeout(boot, 250);
    }
  }
  boot.attempts = 0;

  window.theme = window.theme || {};
  theme.cartLevelDiscount = {
    calculateCartDiscountTotals: calculateCartDiscountTotals,
    applyCartLevelDiscountDisplay: applyCartLevelDiscountDisplay,
    updateCartBanners: updateCartBanners,
    scheduleCartBannerUpdate: scheduleCartBannerUpdate,
    refreshCartDisplay: refreshCartDisplay
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
  } else {
    setTimeout(boot, 0);
  }
})();
